import React from "react";
import { useTranslation } from "react-i18next";

import IconButton from "../../../packages/IconButton";
import { DeleteIcon, EditIcon } from "../../../packages/SVGs";

const ChemicalActionBtnRenderer = ({ data, node, context }) => {
  const { t } = useTranslation();

  const handleBtnClick = ({ target: { name } }) => {
    if (context.onActionBtnClick) {
      const latestChemicalData = node?.data || data;
      context.onActionBtnClick({
        actionType: name,
        chemicalData: latestChemicalData,
      });
    }
  };

  return (
    <div className="d-flex">
      <IconButton
        id={`edit_chemical_${data.id}_btn`}
        name="edit-chemical-btn"
        tooltip={t("ValueStrings.edit")}
        aria-label="edit"
        onClick={handleBtnClick}
      >
        <EditIcon />
      </IconButton>
      {/* delete button is disabled as not part of current requirement*/}
      <IconButton
        id={`delete_chemical_${data.id}_btn`}
        name="delete-chemical-btn"
        disabled
        tooltip={t("ValueStrings.delete")}
        aria-label="delete"
        onClick={handleBtnClick}
      >
        <DeleteIcon disabled />
      </IconButton>
    </div>
  );
};

export default ChemicalActionBtnRenderer;
